<div class="tag full-max-width">
  <p class="no-margin font-weight-semibold tag-label">
    {{ value }}
  </p>
</div>
